/** Bugsnag for catching JS errors */
import Bugsnag from '@bugsnag/js';
import BugsnagPerformance from "@bugsnag/browser-performance";
import BugsnagPluginVue from '@bugsnag/plugin-vue';

let enabled = process.env.MIX_BUGSNAG_ENABLED ? process.env.MIX_BUGSNAG_ENABLED.toLowerCase() === 'true' : false;
let performanceEnabled = process.env.MIX_BUGSNAG_PERFORMANCE_ENABLED ? process.env.MIX_BUGSNAG_PERFORMANCE_ENABLED.toLowerCase() === 'true' : false;
let apiKey = process.env.MIX_BUGSNAG_API_KEY || null
let trackSessions = process.env.MIX_BUGSNAG_CAPTURE_SESSIONS ? process.env.MIX_BUGSNAG_CAPTURE_SESSIONS.toLowerCase() === 'true' : false;
let releaseStage = process.env.MIX_APP_ENV || 'production'

if (enabled){
    Bugsnag.start({
        apiKey,
        plugins: [new BugsnagPluginVue()],
        autoTrackSessions: trackSessions,
        releaseStage,
        appVersion: '3.0.0',
        enabledBreadcrumbTypes: ['error', 'navigation', 'request', 'user']
    });

    if (dataStore.user){
        Bugsnag.setUser(dataStore.user.id, dataStore.user.url, dataStore.user.name);
    }
}

if(performanceEnabled && apiKey){
    BugsnagPerformance.start({
        apiKey: apiKey,
        releaseStage: ['dev', 'staging', 'prod'],
    });
}
